import { useTranslation } from 'react-i18next';

import { ETriggerActivityType } from '@/src/infrastructure/interfaces/IAutomation.interface';
const TRANSLATE_RULES_TYPES = 'ALL_CARDS_ACTIONS.RULES_TYPES';

export const useTranslationsTypesRules = () => {
  const { t } = useTranslation();

  const rulesTypesTrans: { [K in ETriggerActivityType]?: string } = {
    [ETriggerActivityType.TRIGGER_DATE]: t(`${TRANSLATE_RULES_TYPES}.TYPES.rulesDate.title`),
    [ETriggerActivityType.ASSOCIATED_TAG]: t(`${TRANSLATE_RULES_TYPES}.TYPES.tagAssociated.title`),
    [ETriggerActivityType.EXTERNAL_URL_CALL]: t(`${TRANSLATE_RULES_TYPES}.TYPES.externalURL.title`),
    [ETriggerActivityType.API_INTEGRATOR]: t(`${TRANSLATE_RULES_TYPES}.TYPES.fromAPI.title`),
    [ETriggerActivityType.FORM]: t(`${TRANSLATE_RULES_TYPES}.TYPES.fromForm.title`),
  };

  return { rulesTypesTrans };
};
